import { render, staticRenderFns } from "./ObjekPajakNopPermohonan.vue?vue&type=template&id=2514b92a&scoped=true&"
import script from "./ObjekPajakNopPermohonan.vue?vue&type=script&lang=js&"
export * from "./ObjekPajakNopPermohonan.vue?vue&type=script&lang=js&"
import style0 from "./ObjekPajakNopPermohonan.vue?vue&type=style&index=0&id=2514b92a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514b92a",
  null
  
)

export default component.exports